import { Col, FormInstance, Row } from "antd";
import { CustomForm } from "../../Form/index.styled";
import { CheckableTagForm } from "./Form/CheckableTag";
import { RadioGroupForm } from "./Form/RadioGroup";

interface UserInfoServiceWheelAlignmentFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
}

/**
 * 휠얼라인먼트
 * @param param0
 * @returns
 */
export const UserInfoServiceWheelAlignmentForm: React.FC<
  UserInfoServiceWheelAlignmentFormProps
> = ({ form, readonly = false }) => {
  return (
    <>
      <CustomForm.Item>
        <RadioGroupForm
          name={[
            "repairShopOption",
            "options",
            "services",
            "wheelalignment",
            "isActivated",
          ]}
          rules={[
            {
              required: true,
            },
          ]}
          readonly={readonly}
        />
      </CustomForm.Item>
      <CustomForm.Item noStyle shouldUpdate>
        {({ getFieldValue }) =>
          getFieldValue([
            "repairShopOption",
            "options",
            "services",
            "wheelalignment",
            "isActivated",
          ]) && (
            <CustomForm.Item
              name={[
                "repairShopOption",
                "options",
                "services",
                "wheelalignment",
              ]}
              rules={[
                {
                  validator: (rule, value) => {
                    if (value && value?.isActivated === true) {
                      const checked = Object.entries(value).filter(
                        ([key, val]) => key !== "isActivated" && val === true
                      );

                      if (checked.length > 0) {
                        return Promise.resolve();
                      }
                    }
                    return Promise.reject(new Error("하나 이상 선택하세요."));
                  },
                },
              ]}
            >
              <Row gutter={[0, 8]}>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "wheelalignment",
                      "domesticVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "wheelalignment",
                        "domesticVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      국산차(내연)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "wheelalignment",
                      "incomeVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "wheelalignment",
                        "incomeVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차(내연)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "wheelalignment",
                      "domesticElectricVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "wheelalignment",
                        "domesticElectricVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      국산차(전기)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "wheelalignment",
                      "incomeElectricVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "wheelalignment",
                        "incomeElectricVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차(전기)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
              </Row>
            </CustomForm.Item>
          )
        }
      </CustomForm.Item>
    </>
  );
};
